<div class="header-main">
    <core-title-section [title]="title" [breadcrumbs]="breadcrumbs"></core-title-section>
    <div [hidden]="edit || version == null || matchLabels.length == 0" class="labels-edit-container">
        <core-labels-text [labels]="matchLabels"></core-labels-text>
        <span class="plus" [hidden]="diffLabels.length == 0">+ </span>
        <core-labels-text [labels]="diffLabels"></core-labels-text>
    </div>
      <div class="loader" [hidden]="version != null">
        <div class="dimmed">
          <div class="dimmed_content">
            <div class="dimmed_flex dimmed_flex_no">
              <span class="dimmed_tag"></span>
              <span class="dimmed_tag"></span>
              <span class="dimmed_tag"></span>
            </div>
          </div>
        </div>
      </div>
    <app-helpers-labels-edit-diff-box *ngIf="version != null" 
      [hidden]="!edit"
      [allowClose]="true"
      [labels]="version.labels"
      [headerText]="''"
      (labelsChange)="onSetLabels($event)"
      (close)="toggleEdit()"
    ></app-helpers-labels-edit-diff-box>
    <version-helper-three-dot-status-update-menu
        *ngIf="version != null && menu.length > 0"
        [version]="version"
        [menu]="menu"
        (action)="onMenuSelect($event)"
        (actionStatus)="onStatusMenuSelect($event)"
    ></version-helper-three-dot-status-update-menu>
    <!-- bulkEdition -->
    <core-helpers-box-alert-message-icon
      [hidden]="!edit || !bulkEdition"
      [text]="alertText"
      [icon]="'warning'"
    ></core-helpers-box-alert-message-icon>
</div>
